import React from 'react';
import './TrialTopHeader.css';
import $ from 'jquery';
import { useDebounce } from '../../hooks/useDebounce';
import tooltipIcon from './images/alert-circle.svg';
import closeIcon from './images/close-x.svg';

export const TrialTopHeader = ({
                                 fixedClassNamesToMove = '',
                                 descriptionText, pillDisplayText, tooltipText, handleClick,
                               }) => {

  const handleJSScripts = () => {
    //TOOLTIP HANDLE
    $('.top-header-icon-container').on('mouseover', function() {
      $(this).find('.tooltip-trial').show();
    });
    $('.top-header-icon-container').on('mouseout', function() {
      $(this).find('.tooltip-trial').hide();
    });
    //ADDITIONAL ELEMENTS TO MOVE DOWN
    if (fixedClassNamesToMove !== '') {
      $(fixedClassNamesToMove).css('top', '+=30');
    }
    $('body').css('padding-top', '+=30');
    
    //ON TRIAL CLOSURE
    $(document).on('click', '.top-header-closer-container', function() {
      $('.ibl-trial-top-header').hide();
      $('body').css('padding-top', '-=30');
      if (fixedClassNamesToMove !== '') {
        $(fixedClassNamesToMove).css('top', '-=30');
      }
    });
  };

  useDebounce(handleJSScripts, 200, []);

  return (
    <>
      {/*<TrialTopHeaderStyles />*/}
      <div className="site-top-header ibl-trial-top-header">
        <div className="w-layout-hflex site-top-header-container">
          <div data-w-id="16213f3d-be52-d559-0a8b-d87aa0856154"
                                       className="w-layout-hflex top-header-icon-container">
            <img
              src={tooltipIcon}
              loading="lazy" height="20" alt="" className="top-header-img" />
            <div className="tooltip tooltip-trial" style={{ display: 'none' }}>{tooltipText}
            </div>
          </div>
          <div className="top-header-text">{descriptionText}</div>
          <a href="#" onClick={() => handleClick()}
                                  className="top-header-question-link w-inline-block">
            <div
              className="top-header-text pill">{pillDisplayText}</div>
          </a>
          <div prop-events-value-onclick="handleTopHeaderCloseClick"
                                         prop-events-names="onClick"
                                         className="w-layout-hflex top-header-closer-container">
            <img
              src={closeIcon}
              loading="lazy" alt="" className="top-header-closer-icon" /></div>
        </div>
      </div>
    </>

  );
};

/*const TrialTopHeaderStyles = createGlobalStyle`
    .ibl-trial-top-header.site-top-header {
        height: 35px;
        background-image: linear-gradient(135deg, #2467eb, rgba(36, 103, 235, .75) 65%);
        position: relative;
    }

    .ibl-trial-top-header .site-top-header-container {
        height: 100%;
        grid-column-gap: 13px;
        grid-row-gap: 13px;
        justify-content: center;
        align-items: center;
    }

    .ibl-trial-top-header .w-layout-hflex {
        flex-direction: row;
        align-items: flex-start;
        display: flex;
    }

    .ibl-trial-top-header .top-header-icon-container {
        width: 16px;
        height: 100%;
        cursor: pointer;
        justify-content: center;
        align-items: center;
        position: relative;
    }

    .ibl-trial-top-header .top-header-text {
        color: #fff;
        font-size: .85rem;
    }

    .ibl-trial-top-header .w-inline-block {
        max-width: 100%;
        display: inline-block;
    }

    .ibl-trial-top-header a {
        color: #2467eb;
        text-decoration: none;
    }

    .ibl-trial-top-header a {
        background-color: rgba(0, 0, 0, 0);
    }

    .ibl-trial-top-header .top-header-closer-container {
        width: 30px;
        height: 100%;
        opacity: .7;
        cursor: pointer;
        justify-content: center;
        align-items: center;
        position: absolute;
        top: 0%;
        bottom: 0%;
        left: auto;
        right: 0%;
    }

    .ibl-trial-top-header .top-header-closer-icon {
        width: 20px;
        filter: invert();
    }

    .ibl-trial-top-header img {
        max-width: 100%;
        vertical-align: middle;
        display: inline-block;
    }

    .ibl-trial-top-header img {
        border: 0;
    }

    .ibl-trial-top-header .top-header-text.pill {
        border: 1px solid var(--white);
        border-radius: 15px;
        padding: 1px 10px;
    }

    .ibl-trial-top-header .tooltip.tooltip-trial {
        height: 50px;
        flex: none;
        display: none;
        top: 30px;
        left: -160px;
    }

    .ibl-trial-top-header .tooltip {
        z-index: 2147483647;
        width: 350px;
        height: 30px;
        max-width: 390px;
        color: var(--white);
        text-align: center;
        background-color: rgba(0, 0, 0, .75);
        border: 1px solid #000;
        border-radius: 4px;
        flex-wrap: nowrap;
        flex: 0 auto;
        justify-content: center;
        align-self: auto;
        align-items: center;
        padding: 0 10px;
        font-size: 13px;
        display: flex;
        position: absolute;
        top: -34px;
        bottom: auto;
        left: auto;
        right: auto;
    }

    .site-top-header {
        position: fixed !important;
    }
`;*/

/*const TrialMainContainer = styled.div`
    position: fixed;
    top: 0%;
    z-index: 999999;
    width: 100%;
    height: 35px;
    background-image: linear-gradient(135deg, #2467eb, rgba(36, 103, 235, .75) 65%);
`;

const TrialSiteTopHeaderContainer = styled.div`
    height: 100%;
    grid-column-gap: 13px;
    grid-row-gap: 13px;
    justify-content: center;
    align-items: center;
`;

const TrialTopHeaderIconContainer = styled.div`
    width: 16px;
    height: 100%;
    cursor: pointer;
    justify-content: center;
    align-items: center;
    position: relative;
    flex-direction: row;
    display: flex;
`;

const TrialTooltip = styled.div`
    z-index: 2147483647;
    width: 350px;
    height: auto;
    max-width: 390px;
    color: var(--white);
    text-align: center;
    background-color: rgba(0, 0, 0, .75);
    border: 1px solid #000;
    border-radius: 4px;
    flex-wrap: nowrap;
    flex: 0 auto;
    justify-content: center;
    align-self: auto;
    align-items: center;
    padding: 0 10px;
    font-size: 13px;
    display: flex;
    position: absolute;
    top: -34px;
    bottom: auto;
    left: auto;
    right: auto;
    flex: none;
    display: none;
    top: 30px;
    left: -160px;
`;

const TrialTopHeaderText = styled.div`
    color: #fff;
    font-size: inherit;
`;

const TrialTopHeaderTextLinkContent = styled.div`
    border: 1px solid var(--white);
    border-radius: 15px;
    padding: 1px 10px;
`;
const TrialTopHeaderTextLink = styled.a`
    max-width: 100%;
    display: inline-block;
    color: #FFF;
    text-decoration: unset;
    font-size: .90rem;
`;

const TrialTopHeaderCloserContainer = styled.div`
    width: 30px;
    height: 100%;
    opacity: .7;
    cursor: pointer;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0%;
    bottom: 0%;
    left: auto;
    right: 0%;
`;

const TrialCloserIcon = styled.img`
    width: 20px;
    filter: invert();
    max-width: 100%;
    vertical-align: middle;
    display: inline-block;
    border: 0;
`;

const TrialTooltipIcon = styled.img`
    width: 20px;
    filter: invert();
    max-width: 100%;
    vertical-align: middle;
    display: inline-block;
    border: 0;
`;*/

